/**
 * [INPUT]: 依赖 React Context 与 ThemeProvider 注入的当前主题状态
 * [OUTPUT]: 对外提供 Theme、ThemeContext 与 useTheme hook
 * [POS]: app 的主题共享契约，使 ThemeProvider 保持纯组件导出并供切换器消费
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { createContext, useContext } from 'react'

export type Theme = 'paper-white' | 'paper-warm' | 'night-ink'

export interface ThemeContextValue {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext)
  if (!value) throw new Error('useTheme 必须在 ThemeProvider 内使用')
  return value
}
